import { Directive, ElementRef, Input, Renderer2, OnInit, HostListener } from '@angular/core';
import { FeatureHelperService } from './feature-helper.service';

@Directive({
    selector: '[checkFeatureReadOnly]',
    standalone: false
})
export class FeatureHelperCheckReadOnlyDirective implements OnInit {

  public feature: string;

  @Input() set checkFeatureReadOnly(feature: string) {
    this.feature = feature;
  }

  constructor(
    private renderer: Renderer2, 
    private hostElement: ElementRef,
    private featureHelperService: FeatureHelperService
  ) { }

  ngOnInit() {
    let userFeatures = this.featureHelperService.getUserFeatures();
    let itemIndex = userFeatures.map(m => m.feature).indexOf(this.feature);
    if (itemIndex == -1 || !userFeatures[itemIndex].enabled) {
      this.renderer.setAttribute(this.hostElement.nativeElement, "disabled", "true");
      this.renderer.setAttribute(this.hostElement.nativeElement, "readonly", "true");
      this.renderer.removeAttribute(this.hostElement.nativeElement, "required");
      this.renderer.addClass(this.hostElement.nativeElement, 'disable-feature-element');
    }
  }

}
